
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_15dxs_1ns0c_5"
};
  